import { Component, OnInit } from '@angular/core';
import { NeproseService } from '../services/neprose.service';
import { environment } from 'src/environments/environment';
import { DomSanitizer } from '@angular/platform-browser';
import { SeoSocialShareData, SeoSocialShareService } from 'ngx-seo';

@Component({
  selector: 'app-blog',
  templateUrl: './blog.component.html',
  styleUrls: ['./blog.component.css']
})
export class BlogComponent implements OnInit {

  blogList = []

  selectedDate: any = 'new'

  page: number = 1

  loading: boolean

  lastpage: number

  featuredBlog: any

  firstLoading: boolean

  backgroundImageURL: any = this._sanitizer.bypassSecurityTrustStyle(`url(${'assets/banner.jpg'})`+` no-repeat fixed center`)

  seoData: SeoSocialShareData = {
    title:  'Neprose - Blogs',
    description: 'Your next real estate investment opportunity could be right around the corner.',
    image: environment.url+'/assets/logo.png'
  };

  constructor( private neproseService: NeproseService, private _sanitizer: DomSanitizer, private seo: SeoSocialShareService) { }

  ngOnInit(): void {
    this.seo.setData(this.seoData)
    this.neproseService.getBannerImage(4).subscribe(data => {
      if(data.status){
        let banner = data.homeBanner
        this.backgroundImageURL = this._sanitizer.bypassSecurityTrustStyle(`url(${environment.api+'/images/'+banner.imagePath})`+` no-repeat fixed center`)
      }
    })
    this.firstLoading = true
    this.getBlogs()
    
  }

  getBlogs(){
    this.blogList = []
    this.loading = true
    let offset = (this.page - 1)*10
    this.neproseService.getBlogs(offset, this.selectedDate).subscribe(data => {
      this.firstLoading = false
      this.loading = false
      if(data && data.status){
        let blogList = data.blogs
        this.lastpage = Math.ceil(data.total/10)
        if(this.page > this.lastpage){
          this.page = 1
        }
        if(blogList.length > 0){
          this.featuredBlog = blogList[0]
          this.featuredBlog['backgroundImageURL'] = this._sanitizer.bypassSecurityTrustStyle(`url(${'assets/banner.jpg'})`+` no-repeat center`)
          if(this.featuredBlog.imagePath){
            this.featuredBlog['backgroundImageURL'] = this._sanitizer.bypassSecurityTrustStyle(`url(${environment.api+'/images/'+this.featuredBlog.imagePath})`+` no-repeat center`) 
          }
          let excerpt = this.featuredBlog.body.replace(/<\/?[^>]+(>|$)/g, '')
          if(excerpt){
            this.featuredBlog['excerpt'] = excerpt.slice(0, 300)
          }else{
            this.featuredBlog['excerpt'] = ''
          }
          this.featuredBlog['publishedDate'] = new Date(this.featuredBlog['updatedAt']).toDateString()
          console.log(this.featuredBlog)
          blogList.splice(0, 1)
          for(let blog of blogList){
            blog['featuredImage'] = environment.api + '/images/' + blog['imagePath']
            blog['backgroundImageURL'] = this._sanitizer.bypassSecurityTrustStyle(`url(${environment.api+'/images/'+blog.imagePath})`+` no-repeat center`)
            blog['publishedDate'] = new Date(blog['updatedAt']).toDateString()
            let excerpt = blog.body.replace(/<\/?[^>]+(>|$)/g, '')
            let blogLength = excerpt.length
            let minRead = Math.ceil(blogLength/1000)
            if(minRead > 1){
              blog['minRead'] = minRead +' mins read'
            }else{
              blog['minRead'] = minRead +' minute read' 
            }
            if(excerpt){
              blog['excerpt'] = excerpt.slice(0, 100)
            }else{
              blog['excerpt'] = ''
            }
            this.blogList.push(blog)
          }
        }
      }
    }, error => {
      this.loading = false
      this.firstLoading = false
    })
  }

  firstPage(){
    if(this.page != 1){
      this.page = 1
      this.loading = true
      this.getBlogs()
    }
  }

  previousPage(){
    if(this.page > 1){
      this.page = this.page - 1
      this.loading = true
      this.getBlogs()
    }
  }

  nextPage(){
    if(this.page < this.lastpage){
      this.page = this.page + 1
      this.loading = true
      this.getBlogs()
    }
  }

  lastPage(){
    if(this.page != this.lastpage){
      this.page = this.lastpage
      this.loading = true
      this.getBlogs()
    } 
  }


}
